import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";

/*
 *@author   tonicli
 *@date     2016/9/16
 */
import { buildUrl } from './url';
var BASE_URL = "".concat(/^(http|https):$/.test(location.protocol) ? location.protocol : 'https:', "//btrace.qq.com/kvcollect");

function _handle() {}

function _isObject(value) {
  var type = _typeof(value);

  return !!value && (type === 'object' || type === 'function');
}

function _mapValues(obj, iter) {
  if (!_isObject(obj)) {
    return obj;
  } else {
    var retObj = {};

    for (var p in obj) {
      retObj[p] = iter(obj[p]);
    }

    return retObj;
  }
}

function _encodeDollor2(content) {
  if (typeof content !== 'string') {
    return content;
  }

  return content.replace(/\$/g, '|||');
}
/**
 *@param cfg object {bossId:xxx, pwd: xxx}
 */


var Boss = /*#__PURE__*/function () {
  function Boss(cfg) {
    _classCallCheck(this, Boss);

    if (!cfg || !cfg.bossId || !cfg.pwd && parseInt(cfg.pwd) !== 0) {
      throw new Error('[report.Boss]bossId and pwd is required');
    }

    this._cfg = cfg;
    this._baseUrl = buildUrl(cfg.baseUrl || BASE_URL, {
      BossId: cfg.bossId,
      Pwd: cfg.pwd
    });
  }

  _createClass(Boss, [{
    key: "report",
    value: function report(params) {
      this._doReport(this.buildReportUrl(params));

      return this;
    }
  }, {
    key: "buildReportUrl",
    value: function buildReportUrl(params) {
      var self = this;
      var url = buildUrl(self._baseUrl, _mapValues(params, function (v) {
        if (_isObject(v)) {
          try {
            v = JSON.stringify(v);
          } catch (e) {}
        }

        return _encodeDollor2(v);
      }), true);
      return _encodeDollor2(url);
    }
  }, {
    key: "setBaseUrl",
    value: function setBaseUrl(url) {
      this._baseUrl = url;
      return this;
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return this._baseUrl;
    }
  }, {
    key: "_doReport",
    value: function _doReport(url) {
      var reportObject = document.createElement('img');
      reportObject.onerror = reportObject.onload = reportObject.onabort = _handle;
      reportObject.src = url;
      return this;
    }
  }, {
    key: "_encodeDollor",
    value: function _encodeDollor(content) {
      return _encodeDollor2(content);
    }
  }]);

  return Boss;
}();

export { Boss as default };